exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header{padding:10px;background-color:#f5f5f5;border-bottom:1px solid #e5e5e5}.header-logo{float:left;margin-right:10px}#repoLink{width:480px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/NavBar.vue
 ** module id = 101
 ** module chunks = 0
 **/